import { SortOrder } from "interfaces/SortOrder";
import { IPreferredConditionsMatchingHorseInfo } from "interfaces/PreferredConditionsMatchingHorsesSliderState";
import { checkSortingType } from "utils/sort-utils";

type TSortFn = (
  p1: IPreferredConditionsMatchingHorseInfo,
  p2: IPreferredConditionsMatchingHorseInfo
) => number;

export const getSortFn = (
  orderBy: keyof IPreferredConditionsMatchingHorseInfo,
  order: SortOrder
): TSortFn => {
  const { isAsc } = checkSortingType(order);
  const multiplier = isAsc ? 1 : -1;
  switch (orderBy) {
    case "horseName":
      return (hi1, hi2) =>
        hi1.horseName.localeCompare(hi2.horseName) * multiplier;
    case "trainerName":
      return (hi1, hi2) =>
        hi1.trainerName.localeCompare(hi2.trainerName) * multiplier;
    case "daysOff":
      return (hi1, hi2) => (hi1.daysOff - hi2.daysOff) * multiplier;
    case "isLastRace":
      return (hi1, hi2) =>
        (Number(hi1.isLastRace) - Number(hi2.isLastRace)) * multiplier;
  }
};
